<template>
  <div>
    <div v-show="this.sofaTitle" stype="margin-bottom:10px;"><marquee style="color:red;width:100%;behavior:alternate;direction:left;font-size:16px;" >应急预警! {{ sofaTitle }}</marquee></div>
    <!-- 图片按钮+ 地图连接 -->
    <context-box></context-box>
    <div class="img-bar"></div>
    <!-- 农业服务 -->
    <info-box ref="nyInfoBox" :lImg="nyImg" :tabs="nyTab" @change="nyTabChange">
      <!-- 新闻发布 -->
      <a-spin style="width:100%;" :spinning="nyData[0].loading" v-show="nyTabAciveKey === 'xwzx'">
        <router-link
          class="info-row"
          v-for="item in nyData[0].data.slice(0, 7)"
          :key="item.id"
          target="_blank"
          :to="{ path: '/Textcontent', query: { id: item.id } }"
        >
          <div class="title-cel">
            <img :src="dot" style="margin-right:5px;">{{ item.title }}
          </div>
          <div class="date-cel">{{ item.publishTime | dateFileter }}</div>
        </router-link>
      </a-spin>
      <!-- 政策法规 -->
      <a-spin style="width:100%;" :spinning="nyData[1].loading" v-show="nyTabAciveKey === 'zcfg'">
        <router-link
          class="info-row"
          v-for="item in nyData[1].data.slice(0, 7)"
          :key="item.id"
          target="_blank"
          :to="{ path: '/Textcontent', query: { id: item.id } }"
        >
          <div class="title-cel">
            <img :src="dot" style="margin-right:5px;"> {{ item.title }}
          </div>
          <div class="date-cel">{{ item.publishTime | dateFileter }}</div>
        </router-link>
      </a-spin>
      <!-- 土地托管 -->
      <div class="mini-box" v-show="nyTabAciveKey === 'tdtg'">
        <div class="mini-box-item">
          <mini-title-bar
            label="土地全托"
            :morePath="{ path: '/BusinessList', query: { nc: 'BL_2_1' } }"
          />
          <a-spin style="width:100%" :spinning="nyData[2].loading">
            <router-link
              class="info-row"
              v-for="item in nyData[2].data[0].slice(0, 7)"
              :key="item.id"
              target="_blank"
              :to="{ path: '/LandTrustPage', query: { id: item.id } }"
            >
              <div class="title-cel">
                <img :src="dot" style="margin-right:5px;">{{ item.publishTitle }}
              </div>
              <div class="date-cel">{{ item.publishDate | moment('MM-DD') }}</div>
            </router-link>
          </a-spin>
        </div>
        <div class="mini-box-item">
          <mini-title-bar
            label="土地半托"
            :morePath="{ path: '/BusinessList', query: { nc: 'BL_2_2' } }"
          />
          <a-spin style="width:100%" :spinning="nyData[2].loading">
            <router-link
              class="info-row"
              v-for="item in nyData[2].data[1].slice(0, 7)"
              :key="item.id"
              target="_blank"
              :to="{ path: '/LandTrustPage', query: { id: item.id } }"
            >
              <div class="title-cel">
                <img :src="dot" style="margin-right:5px;">{{ item.publishTitle }}
              </div>
              <div class="date-cel">{{ item.publishDate | moment('MM-DD') }}</div>
            </router-link>
          </a-spin>
        </div>
      </div>
      <!-- 土地流转 -->
      <a-spin style="width:100%;" :spinning="nyData[3].loading" v-show="nyTabAciveKey === 'tdlz'">
        <div class="info-row" style="background-color: #f0f0f0;">
          <div class="title-cel">片区名称</div>
          <div style="width:150px">片区面积</div>
          <div style="width:100px">租赁价格</div>
          <div class="date-cel">发布日期</div>
        </div>
        <router-link
          class="info-row"
          v-for="item in nyData[3].data.slice(0, 6)"
          :key="item.id"
          target="_blank"
          :to="{ path: '/Textcontent', query: { id: item.id, sytype: 'LandTransferArea' } }"
        >
          <div class="title-cel">
            <img :src="dot" style="margin-right:5px;">{{ item.areaName }}
          </div>
          <div style="width:150px">{{ item.areaSize }}亩</div>
          <div style="width:100px">{{ item.price }}元/亩</div>
          <div class="date-cel">{{ item.publishDate | moment('YYYY.MM.DD') }}</div>
        </router-link>
      </a-spin>
      <!-- 通知公告 -->
      <div v-show="nyTabAciveKey === 'tzgg'">
        <a-spin style="width:100%;" :spinning="nyData[4].loading">
          <router-link
            class="info-row"
            v-for="item in nyData[4].data.slice(0, 7)"
            :key="item.id"
            target="_blank"
            :to="{ path: '/Textcontent', query: { id: item.id } }"
          >
            <div class="title-cel">
              <img :src="dot" style="margin-right:5px;">{{ item.title }}
            </div>
            <div class="date-cel">{{ item.publishTime }}</div>
          </router-link>
        </a-spin>
      </div>
    </info-box>
    <!-- 衍生服务 -->
    <info-box ref="ysInfoBox" :lImg="ysImg" :tabs="ysTab" @change="ysTabChange">
      <!-- 科技展翅 -->
      <a-spin style="width:100%;" :spinning="ysData[0].loading" v-show="ysTabActiveKey === 'kjzc'">
        <router-link
          class="info-row"
          v-for="item in ysData[0].data.slice(0, 7)"
          :key="item.id"
          target="_blank"
          :to="{ path: '/Textcontent', query: { id: item.id } }"
        >
          <div class="title-cel">
            <img :src="dot" style="margin-right:5px;">{{ item.title }}
          </div>
          <div class="date-cel">{{ item.publishTime }}</div>
        </router-link>
      </a-spin>
      <!-- 经营主体 -->
      <a-spin style="width:100%;" :spinning="ysData[1].loading" v-show="ysTabActiveKey === 'jyzt'">
        <tab-menu :tabs="jyztTab" @change="jyztTabChange" />
        <!-- 家庭农场 -->
        <div v-show="this.ysData[1].entActiveIndex == 3">
          <router-link
            class="info-row"
            v-for="item in ysData[1].data[0]"
            :key="item.id"
            target="_blank"
            :to="{ path: '/BusinessEntityPage', query: { id: item.id } }"
          >
            <div class="title-cel">
              <img :src="dot" style="margin-right:5px;">{{ item.sName }}
            </div>
            <div class="date-cel">{{ item.createTime }}</div>
          </router-link>
        </div>
        <!-- 农村合作社 -->
        <div v-show="this.ysData[1].entActiveIndex == 2">
          <router-link
            class="info-row"
            v-for="item in ysData[1].data[1]"
            :key="item.id"
            target="_blank"
            :to="{ path: '/BusinessEntityPage', query: { id: item.id } }"
          >
            <div class="title-cel">
              <img :src="dot" style="margin-right:5px;">{{ item.sName }}
            </div>
            <div class="date-cel">{{ item.createTime }}</div>
          </router-link>
        </div>
        <!-- 龙头企业 -->
        <div v-show="this.ysData[1].entActiveIndex == 1">
          <router-link
            class="info-row"
            v-for="item in ysData[1].data[2]"
            :key="item.id"
            target="_blank"
            :to="{ path: '/BusinessEntityPage', query: { id: item.id } }"
          >
            <div class="title-cel">
              <img :src="dot" style="margin-right:5px;">{{ item.sName }}
            </div>
            <div class="date-cel">{{ item.createTime }}</div>
          </router-link>
        </div>
        <!-- 服务组织 -->
        <div v-show="this.ysData[1].entActiveIndex == 4">
          <router-link
            class="info-row"
            v-for="item in ysData[1].data[3]"
            :key="item.id"
            target="_blank"
            :to="{ path: '/BusinessEntityPage', query: { id: item.id } }"
          >
            <div class="title-cel">
              <img :src="dot" style="margin-right:5px;">{{ item.sName }}
            </div>
            <div class="date-cel">{{ item.createTime }}</div>
          </router-link>
        </div>
      </a-spin>
      <sigin-search-btn :morePath="{ path: '/BusinessEntity', query: { nc: 'BE_3' } }" v-show="ysData[1].entActiveIndex === 3" />
      <sigin-search-btn :morePath="{ path: '/BusinessEntity', query: { nc: 'BE_2' } }" v-show="ysData[1].entActiveIndex === 2" />
      <sigin-search-btn :morePath="{ path: '/BusinessEntity', query: { nc: 'BE_1' } }" v-show="ysData[1].entActiveIndex === 1" />
      <sigin-search-btn :morePath="{ path: '/BusinessEntity', query: { nc: 'BE_4' } }" v-show="ysData[1].entActiveIndex === 4" />
      <!-- 农机服务 -->
      <a-spin style="width:100%;" :spinning="ysData[2].loading" v-show="ysTabActiveKey === 'njfw'">
        <div class="info-row" style="background-color: #f0f0f0;">
          <div class="title-cel">农机所有人</div>
          <div style="width:150px">农机具种类</div>
          <div style="width:100px">农机具型号</div>
          <div style="width:100px">作业单价</div>
          <div class="date-cel">发布日期</div>
        </div>
        <router-link
          class="info-row"
          v-for="item in ysData[2].data"
          :key="item.id"
          target="_blank"
          :to="{ path: '/FarmMachinePage', query: { id: item.id } }"
        >
          <div class="title-cel">
            <img :src="dot" style="margin-right:5px;">{{ item.fName }}
          </div>
          <div style="width:150px">{{ item.mType }}</div>
          <div style="width:100px">{{ item.modelNumber }}</div>
          <div style="width:100px">{{ item.price === 0 ? '面议' : item.price + '元' }}</div>
          <div class="date-cel">{{ item.publishDate | dateFileter }}</div>
        </router-link>
      </a-spin>
      <!-- 农村人才 -->
      <a-spin style="width:100%;" :spinning="ysData[3].loading" v-show="ysTabActiveKey === 'ncrc'">
        <tab-menu :tabs="ncrcTab" @change="ncrcTabChange" />
        <!-- 农村劳务 -->
        <div v-show="ysData[3].subActiveIndex === 0">
          <div class="info-row" style="background-color: #f0f0f0;">
            <div style="width:120px">所在村级</div>
            <div style="width:100px">姓名</div>
            <div style="width:60px">性别</div>
            <div style="width:100px">从业状态</div>
            <div style="flex:1">技能专长</div>
            <div style="width:100px">技能年限</div>
            <div class="date-cel">发布日期</div>
          </div>
          <router-link
            class="info-row"
            v-for="item in ysData[3].data[0]"
            :key="item.id"
            target="_blank"
            :to="{ path: '/FarmerInfoPage', query: { id: item.id } }"
          >
            <div style="width:120px">
              <img :src="dot" style="margin-right:5px;">{{ item.sysOrgName }}
            </div>
            <div style="width:100px">{{ item.name }}</div>
            <div style="width:60px">{{ item.gender === 1 ? '男' : '女' }}</div>
            <div style="width:100px">{{ item.employmentStatus }}</div>
            <div style="flex:1">{{ item.expertise | expertiseFilter }}</div>
            <div style="width:100px">{{ item.skillYears }}年</div>
            <div class="date-cel">{{ item.publishTime | dateFileter }}</div>
          </router-link>
        </div>
        <!-- 农村人才 -->
        <div v-show="ysData[3].subActiveIndex === 1">
          <div class="info-row" style="background-color: #f0f0f0;">
            <div style="width:150px">姓名</div>
            <div style="width:60px">性别</div>
            <div style="width:170px">专业专长</div>
            <div style="width:100px">从业年限</div>
            <div style="flex:1">意向服务地区</div>
            <div class="date-cel">发布日期</div>
          </div>
          <router-link
            class="info-row"
            v-for="item in ysData[3].data[1]"
            :key="item.id"
            target="_blank"
            :to="{ path: '/TanlentPage', query: { id: item.id } }"
          >
            <div style="width:150px">
              <img :src="dot" style="margin-right:5px;">{{ item.name }}
            </div>
            <div style="width:60px">{{ item.gender === 1 ? '男' : '女' }}</div>
            <div style="width:170px">{{ item.expertise | TanlentexpertiseFilter }}</div>
            <div style="width:100px">{{ item.numberOfYears }}年</div>
            <div style="flex:1">{{ item.areaOfInterest }}</div>
            <div class="date-cel">{{ item.publishDate | dateFileter }}</div>
          </router-link>
        </div>
      </a-spin>
      <sigin-search-btn :morePath="{ path:'/FarmerLabor', query: { } }" v-show="ysTabActiveKey === 'ncrc' && ysData[3].subActiveIndex === 0"/>
      <sigin-search-btn :morePath="{ path:'/BusinessList', query: { nc: 'BL_0' } }" v-show="ysTabActiveKey === 'ncrc' && ysData[3].subActiveIndex === 1"/>
      <!-- 金融保险 -->
      <div class="mini-box" v-show="ysTabActiveKey === 'jrbx'">
        <div class="mini-box-item">
          <mini-title-bar
            label="农业贷款"
            :morePath="{
              path: '/AgriculturalServices',
              query: { nc: 'I_10' }
            }"
          />
          <a-spin style="width:100%" :spinning="ysData[4].loading">
            <router-link
              class="info-row"
              v-for="item in ysData[4].data[0].slice(0, 6)"
              :key="item.id"
              target="_blank"
              :to="{ path: '/Textcontent', query: { id: item.id } }"
            >
              <div class="title-cel">
                <img :src="dot" style="margin-right:5px;">{{ item.title.length>16? item.title.slice(0, 16)+ '...':item.title }}
              </div>
              <div class="date-cel">{{ item.publishTime | moment('MM-DD') }}</div>
            </router-link>
          </a-spin>
        </div>
        <div class="mini-box-item">
          <mini-title-bar
            label="农业保险"
            :morePath="{
              path: '/AgriculturalServices',
              query: { nc: 'I_11' }
            }"
          />
          <a-spin style="width:100%" :spinning="ysData[4].loading">
            <router-link
              class="info-row"
              v-for="item in ysData[4].data[1].slice(0, 6)"
              :key="item.id"
              target="_blank"
              :to="{ path: '/Textcontent', query: { id: item.id } }"
            >
              <div class="title-cel">
                <img :src="dot" style="margin-right:5px;">{{ item.title.length>16? item.title.slice(0, 16)+ '...':item.title }}
              </div>
              <div class="date-cel">{{ item.publishTime | moment('MM-DD') }}</div>
            </router-link>
          </a-spin>
        </div>
      </div>
    </info-box>
    <!-- 综合展示 -->
    <info-box
      :lImg="zhImg"
      ref="zhInfoBox"
      :tabs="zhTab"
      type="mini"
      @change="zhTabChange"
      :static="true">
      <a :href="this.Rel" target="_blank">
        <div class="publish-btn">
          <span class="publish-btn-Img"><a-icon type="book" /></span>
          <span class="publish-btn-words">发布</span>
        </div>
      </a>
      <div class="mini-box">
        <!-- 价格行情 -->
        <div class="mini-box-item">
          <tab-menu :tabs="jghqTab" @change="jghqTabChange" />
          <a-spin style="width:100%;" :spinning="zhData[0].loading" v-show="zhData[0].activeIndex === 0">
            <router-link
              class="info-row"
              v-for="item in zhData[0].data[0].slice(0, 7)"
              :key="item.id"
              target="_blank"
              :to="{ path: '/Textcontent', query: { id: item.id } }"
            >
              <div class="title-cel">
                <img :src="dot" style="margin-right:5px;">{{ item.title }}
              </div>
            </router-link>
          </a-spin>
          <div v-show="zhData[0].activeIndex === 1">
            <router-link
              class="info-row"
              v-for="item in zhData[0].data[1].slice(0, 7)"
              :key="item.id"
              target="_blank"
              :to="{ path: '/Textcontent', query: { id: item.id } }"
            >
              <div class="title-cel">
                <img :src="dot" style="margin-right:5px;">{{ item.title }}
              </div>
            </router-link>
          </div>
          <sigin-search-btn :morePath="{ path: '/AgriculturalServices', query: { nc: 'I_8' } }" v-show="zhData[0].activeIndex === 0" />
          <sigin-search-btn :morePath="{ path: '/AgriculturalServices', query: { nc: 'I_9' } }" v-show="zhData[0].activeIndex === 1" />
        </div>
        <!-- 供求信息 -->
        <div class="mini-box-item">
          <tab-menu :tabs="gqxxTab" @change="gqxxTabChange" />
          <a-spin style="width:100%;" :spinning="zhData[1].loading" v-show="zhData[1].activeIndex === 0">
            <router-link
              class="info-row"
              v-for="item in zhData[1].data[0].slice(0, 7)"
              :key="item.id"
              target="_blank"
              :to="{ path: '/SupplyandDemandPage', query: { id: item.id } }"
            >
              <div class="title-cel">
                <img :src="dot" style="margin-right:5px;">{{ item.sdTitle }}
              </div>
              <div class="date-cel">{{ item.publishDate |moment('MM-DD') }}</div>
            </router-link>
          </a-spin>
          <div v-show="zhData[1].activeIndex === 1">
            <router-link
              class="info-row"
              v-for="item in zhData[1].data[1].slice(0, 7)"
              :key="item.id"
              target="_blank"
              :to="{ path: '/SupplyandDemandPage', query: { id: item.id } }"
            >
              <div class="title-cel">
                <img :src="dot" style="margin-right:5px;">{{ item.sdTitle }}
              </div>
              <div class="date-cel">{{ item.publishDate|moment('MM-DD') }}</div>
            </router-link>
          </div>
          <sigin-search-btn :morePath="{ path: '/AgriculturalServices', query: { nc: 'Sd_1' } }" v-show="zhData[1].activeIndex === 0" />
          <sigin-search-btn :morePath="{ path: '/AgriculturalServices', query: { nc: 'Sd_2' } }" v-show="zhData[1].activeIndex === 1" />
        </div>
      </div>
    </info-box>
    <title-bar label="品牌展示" :icon="ppImg" :morePath="{ path: '/BusinessList', query: { nc: nc } }"/>
    <span class="other-link">
      <!-- <a @click="WhiteChick" target="_blank" style="color:green">【农产品质量安全追溯】</a>
      <a @click="APIPageChick" target="_blank" style="color:green">【合作社经营管理】</a> -->
    </span>
    <tab-menu :tabs="ppTabs" @change="ppzsTabChange" />
    <div class="img-box">
      <a-spin style="width:100%;" :spinning="ppData[0].loading" v-show="ppTabActive === 0">
        <div style="height:200px;">
          <!-- 内容 -->
          <a-space direction="horizontal" :size="size">
            <div :span="4" v-for="(item, index) of BrandData.slice(0, 6)" :key="index" :value="item.title">
              <a-card hoverable :bodyStyle="{ padding: '0' }" style="text-align:center;">
                <img
                  slot="cover"
                  alt="example"
                  @click="toBrand(item.id)"
                  :src="item.imgUrl"
                  style="width: 160px;height:120px;overflow:hidden;"
                />
                <a-card-meta :title="item.bName" style="width: 160px;padding:0px;"> </a-card-meta>
              </a-card>
            </div>
          </a-space>
        </div>
      </a-spin>
      <a-spin style="width:100%;" :spinning="ppData[1].loading" v-show="ppTabActive === 1">
        <div style="height:200px;">
          <!-- 内容 -->
          <a-space direction="horizontal" :size="size">
            <div :span="4" v-for="(item, index) of RegionalBrandData.slice(0, 6)" :key="index" :value="item.title">
              <a-card hoverable :bodyStyle="{ padding: '0' }" style="text-align:center;">
                <img
                  slot="cover"
                  alt="example"
                  @click="toBrandAgriculture(item.id)"
                  :src="item.imgUrl"
                  style="width: 160px;height:120px;overflow:hidden;"
                />
                <a-card-meta :title="item.bName" style="width: 160px;"> </a-card-meta>
              </a-card>
            </div>
          </a-space>
        </div>
      </a-spin>
      <a-spin style="width:100%;" :spinning="ppData[2].loading" v-show="ppTabActive === 2">
        <div style="height:200px;">
          <!-- 内容 -->
          <a-space direction="horizontal" :size="size">
            <div :span="4" v-for="(item, index) of ProductsData.slice(0, 6)" :key="index" :value="item.title">
              <a-card hoverable :bodyStyle="{ padding: '0' }" style="text-align:center;">
                <img
                  slot="cover"
                  alt="example"
                  @click="toBrand(item.id)"
                  :src="item.imgUrl"
                  style="width: 160px;height:120px;overflow:hidden;"
                />
                <a-card-meta :title="item.bName" style="width: 160px;"> </a-card-meta>
              </a-card>
            </div>
          </a-space>
        </div>
      </a-spin>
    </div>
    <title-bar label="观光农业" :icon="ggImg" :morePath="{ path: '/BusinessList', query: { nc: 'BL_13' } }" />
    <div class="img-box">
      <!-- 这里是观光图片 -->
      <div style="height:200px;">
        <!-- 内容 -->
        <a-space direction="horizontal" :size="size">
          <div :span="4" v-for="(item, index) of SightseetData.slice(0, 6)" :key="index" :value="item.title">
            <a-card hoverable :bodyStyle="{ padding: '0' }" style="text-align:center;">
              <img
                slot="cover"
                alt="example"
                @click="toSightseet(item.id)"
                :src="item.imgUrl"
                style="width: 160px;height:120px;overflow:hidden;"
              />
              <a-card-meta :title="item.pName" style="width: 160px;"> </a-card-meta>
            </a-card>
          </div>
        </a-space>
      </div>
    </div>
    <title-bar label="农资服务" :icon="ppImg" :morePath="{ path: '/AgriculturalServices', query: { nc: 'I_33' } }" />
    <div class="img-box">
      <!-- 这里是农资服务 -->
      <div style="height:200px;">
        <!-- 内容 -->
        <a-space direction="horizontal" :size="size">
          <div :span="4" v-for="(item, index) of BrandDisplayData.slice(0, 6)" :key="index" :value="item.title">
            <a-card hoverable :bodyStyle="{ padding: '0' }" style="text-align:center;">
              <img
                slot="cover"
                alt="example"
                @click="toBrandDisplay(item.id)"
                :src="item.coverPhoto"
                style="width: 160px;height:120px;overflow:hidden;"
              />
              <a-card-meta :title="item.title" style="width: 160px;"> </a-card-meta>
            </a-card>
          </div>
        </a-space>
      </div>
    </div>
    <title-bar label="友情链接" :icon="yqImg" :hideMore="true" />
    <ul class="links">
      <li>
        <a href="http://nyj.weihai.gov.cn/" target="_blank">威海市农业农村局</a>
      </li>
      <li>
        <a href="http://www.weihai.gov.cn/" target="_blank">威海市政府</a>
      </li>
      <li>
        <a href="http://nync.shandong.gov.cn/" target="_blank">山东省农业农村厅</a>
      </li>
      <li>
        <a href="http://www.shandong.gov.cn/" target="_blank">山东省人民政府</a>
      </li>
      <li>
        <a href="http://www.moa.gov.cn/" target="_blank">农业农村部</a>
      </li>
    </ul>

    <!-- <show></show> -->
    <!-- <context-middle></context-middle> -->
  </div>
</template>

<script>
import contextBox from '@/components/contextTop/contextBox.vue'
import citysearchBox from '@/layouts/topBox/cityBox/citysearchBox.vue'
import show from '../../layouts/contextCenter/show.vue'
import contextMiddle from '../../layouts/contextMiddle/contextMiddle.vue'
import InfoBox from '@/components/InfoBox/index.vue'
import TitleBar from '@/components/TitleBar/index.vue'
import MiniTitleBar from '@/components/TitleBar/mini.vue'
import TabMenu from '@/components/TabMenu/index.vue'
import SiginSearchBtn from '@/components/singleSeachBtn/index.vue'
import nyImg from '@/assets/show/index_m0.jpg'
import ysImg from '@/assets/show/index_m1.jpg'
import zhImg from '@/assets/show/index_m2.jpg'
import ppImg from '@/assets/icon/pinpai.png'
import ggImg from '@/assets/icon/guanguang.png'
import yqImg from '@/assets/icon/links.png'
import moment from 'moment'

// import { cityMenu } from '@/config/menuData'
import { InfoMainWebPage } from '@/api/main/InfoMainManage'
import { LandTrustWebPage } from '@/api/main/LandTrustManager'
import { LandTransferAreaWebPage } from '@/api/main/LandTransferAreaManager'
import { FarmMachineInformationWebPage } from '@/api/main/FarmMachineInformationManage'
import { FarmerInfoWebPage } from '@/api/main/FarmerInfoManager'
import { TalentsInfoWebPage } from '@/api/main/TalentsInfoManager'
import { SupplyAndDemandInfoWebPage } from '@/api/main/SupplyAndDemandManager'
import { BrandAgricultureProductsWebPage } from '@/api/main/BrandAgricultureProductsManager'
import { BrandPublicWebPage } from '@/api/main/BrandPublicManager'
import { SightseeingParkInfoWebPage } from '@/api/main/SightseeingParkInfoManage'
import { ExternalList } from '@/api/main/ExternalListManager'
import { ServiceOrgWebPage } from '@/api/main/​ServiceOrgManager'
import dot from '@/assets/icon/dot.png'
export default {
  components: { contextBox, InfoBox, TitleBar, MiniTitleBar, TabMenu, show, contextMiddle, citysearchBox, SiginSearchBtn },
  data() {
    return {
      orgId: null,
      dot: dot,
      nyImg: nyImg,
      size: 5,
      nc: 'BL_12_1',
      nyTab: [
        {
          name: '新闻中心',
          key: 'xwzx',
          infoType: 1,
          active: true,
          index: 0,
          morePath: { path: '/AgriculturalServices', query: { nc: 'I_1' } }
        },
        {
          name: '政策法规',
          infoType: 2,
          key: 'zcfg',
          active: false,
          index: 1,
          morePath: { path: '/AgriculturalServices', query: { nc: 'I_2' } }
        },
        {
          name: '土地托管',
          key: 'tdtg',
          active: false,
          index: 2
        },
        {
          name: '土地流转',
          key: 'tdlz',
          active: false,
          index: 3,
          morePath: { path: '/BusinessList', query: { nc: 'BL_1' } }
        },
        {
          name: '通知公告',
          infoType: 5,
          key: 'tzgg',
          active: false,
          morePath: { path: '/AgriculturalServices', query: { nc: 'I_3' } },
          index: 4
        }
      ],
      ysImg: ysImg,
      ysTab: [
        {
          name: '科技展翅',
          key: 'kjzc',
          active: true,
          index: 0,
          morePath: { path: '/AgriculturalServices', query: { nc: 'I_5' } }
        },
        {
          name: '经营主体',
          key: 'jyzt',
          active: false,
          index: 1
        },
        {
          name: '农机服务',
          key: 'njfw',
          active: false,
          index: 2,
          morePath: { path: '/Farm_Machine', query: { } }
        },
        {
          name: '农村人才',
          key: 'ncrc',
          active: false,
          index: 3
        },
        {
          name: '金融保险',
          key: 'jrbx',
          active: false,
          index: 4
        }
      ],
      zhImg: zhImg,
      zhTab: [
        {
          type: 'mini',
          name: '价格行情',
          key: 'jghq',
          active: true
        },
        {
          type: 'mini',
          name: '供求信息',
          key: 'gqxx',
          active: false
        }
      ],
      ppImg: ppImg,
      ppTabs: [
        {
          name: '知名品牌',
          key: 'ZMPP',
          index: 0,
          nc: 'BL_12_1',
          active: true
        },
        {
          name: '区域品牌',
          key: 'QYPP',
          index: 1,
          nc: 'BL_12_2',
          active: false
        },
        {
          name: '农产品品牌',
          key: 'NCPPP',
          index: 2,
          nc: 'BL_12_3',
          active: false
        }
      ],
      ggImg: ggImg,
      yqImg: yqImg,
      // 农业服务数据
      nyTabAciveKey: 'xwzx',
      nyData: [
        {
          type: 'xwzx',
          firstLoad: true,
          data: [],
          loaded: false,
          loading: false,
          method: () => {
            this.nyData[0].loaded = true
            this.nyData[0].loading = true
            InfoMainWebPage({ orgId: this.orgId, infoType: 1, pageNo: 1, pageSize: 8 })
              .then(res => {
                this.nyData[0].data = res.data.rows
              })
              .catch(err => {
                this.nyData[0].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.nyData[0].loading = false
              })
          }
        },
        {
          type: 'zcfg',
          data: [],
          loaded: false,
          loading: false,
          method: () => {
            this.nyData[1].loaded = true
            this.nyData[1].loading = true
            InfoMainWebPage({ orgId: this.orgId, infoType: 2, pageNo: 1, pageSize: 8 })
              .then(res => {
                this.nyData[1].data = res.data.rows
              })
              .catch(err => {
                this.nyData[1].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.nyData[1].loading = false
              })
          }
        },
        {
          type: 'tdtg',
          data: [[], []],
          loaded: false,
          loading: false,
          method: () => {
            this.nyData[2].loaded = true
            this.nyData[2].loading = true
            LandTrustWebPage({ orgId: this.orgId, tType: 0, pageNo: 1, pageSize: 8 })
              .then(res => {
                this.nyData[2].data[0] = res.data.rows
                LandTrustWebPage({ orgId: this.orgId, tType: 1 })
                  .then(res => {
                    this.nyData[2].data[1] = res.data.rows
                  })
                  .catch(err => {
                    this.nyData[2].loaded = false
                    console.log(err)
                  })
                  .finally(() => {
                    this.nyData[2].loading = false
                  })
              })
              .catch(err => {
                this.nyData[2].loaded = false
                console.log(err)
              })
          }
        },
        {
          type: 'tdlz',
          data: [],
          loaded: false,
          loading: false,
          method: () => {
            this.nyData[3].loaded = true
            this.nyData[3].loading = true
            
            LandTransferAreaWebPage({ orgId: this.orgId, pageNo: 1, pageSize: 8 })
              .then(res => {
                this.nyData[3].data = res.data.rows;
              console.log("this.nyData[3].data===========>",this.nyData[3].data);
              })
              .catch(err => {
                this.nyData[3].loading = false
                console.log(err)
              })
              .finally(() => {
                this.nyData[3].loading = false
              })
          }
        },
        {
          type: 'tzgg',
          data: [],
          loaded: false,
          loading: false,
          method: () => {
            this.nyData[4].loaded = true
            this.nyData[4].loading = true
            InfoMainWebPage({ orgId: this.orgId, infoType: 3, pageNo: 1, pageSize: 8 })
              .then(res => {
                this.nyData[4].data = res.data.rows
              })
              .catch(err => {
                this.nyData[4].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.nyData[4].loading = false
              })
          }
        }
      ],
      // 衍生服务
      ysTabActiveKey: 'kjzc',
      ysData: [
        {
          type: 'kjzc',
          firstLoad: true,
          data: [],
          loaded: false,
          loading: false,
          method: () => {
            this.ysData[0].loaded = true
            this.ysData[0].loading = true
            InfoMainWebPage({ orgId: this.orgId, infoType: 5, pageNo: 1, pageSize: 8 })
              .then(res => {
                this.ysData[0].data = res.data.rows
              })
              .catch(err => {
                this.ysData[0].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.ysData[0].loading = false
              })
          }
        },
        {
          type: 'jyzt',
          firstLoad: true,
          entActiveIndex: 3,
          data: [],
          loaded: false,
          loading: false,
          method: async () => {
            this.ysData[1].loaded = true
            this.ysData[1].loading = true
            await ServiceOrgWebPage({ orgId: this.orgId, SType: 3, pageNo: 1, pageSize: 8 })
              .then(res => {
                this.ysData[1].data[0] = ''
                this.ysData[1].data[0] = res.data.rows.slice(0, 6)
              })
              .finally(() => {
                this.ysData[1].loading = false
              })
             await ServiceOrgWebPage({ orgId: this.orgId, SType: 2, pageNo: 1, pageSize: 8 })
              .then(res => {
                this.ysData[1].data[1] = ''
                this.ysData[1].data[1] = res.data.rows.slice(0, 6)
              })
              .finally(() => {
                this.ysData[1].loading = false
              })
              await ServiceOrgWebPage({ orgId: this.orgId, SType: 1, pageNo: 1, pageSize: 8 })
              .then(res => {
                this.ysData[1].data[2] = ''
                this.ysData[1].data[2] = res.data.rows.slice(0, 6)
              })

              .finally(() => {
                this.ysData[1].loading = false
              })
              await ServiceOrgWebPage({ orgId: this.orgId, SType: 4, pageNo: 1, pageSize: 8 })
              .then(res => {
                this.ysData[1].data[3] = ''
                this.ysData[1].data[3] = res.data.rows.slice(0, 6)
              })
              .finally(() => {
                this.ysData[1].loading = false
              })
          }
        },
        {
          type: 'njfw',
          firstLoad: true,
          data: [],
          loaded: false,
          loading: false,
          method: () => {
            this.ysData[2].loaded = true
            this.ysData[2].loading = true
            FarmMachineInformationWebPage({ orgId: this.orgId, pageNo: 1, pageSize: 6 })
              .then(res => {
                this.ysData[2].data = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.ysData[2].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.ysData[2].loading = false
              })
          }
        },
        {
          type: 'ncrc',
          firstLoad: true,
          subActiveIndex: 0,
          data: [[], []],
          loaded: false,
          loading: false,
          method: async () => {
            this.ysData[3].loaded = true
            this.ysData[3].loading = true
            await TalentsInfoWebPage({ orgId: this.orgId, pageNo: 1, pageSize: 5 })
              .then(res => {
                this.ysData[3].data[1] = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                console.log(err)
              })
            await FarmerInfoWebPage({ orgId: this.orgId, pageNo: 0, pageSize: 5 })
              .then(res => {
                this.ysData[3].data[0] = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.ysData[3].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.ysData[3].loading = false
              })
          }
        },
        {
          type: 'jrbx',
          firstLoad: true,
          data: [[], []],
          loaded: false,
          loading: false,
          method: async () => {
            this.ysData[4].loaded = true
            this.ysData[4].loading = true
            await InfoMainWebPage({ orgId: this.orgId, infoType: 11, pageNo: 1, pageSize: 7 })
              .then(res => {
                this.ysData[4].data[1] = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.ysData[4].loaded = false
                console.log(err)
              })
            await InfoMainWebPage({ orgId: this.orgId, infoType: 10, pageNo: 1, pageSize: 7 })
              .then(res => {
                this.ysData[4].data[0] = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.ysData[4].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.ysData[4].loading = false
              })
          }
        }
      ],
      zhTabActiveKey: 'jghq',
      zhData: [
        {
          type: 'jghq',
          firstLoad: true,
          activeIndex: 0,
          data: [[], []],
          loaded: false,
          loading: false,
          method: async () => {
            this.zhData[0].loaded = true
            this.zhData[0].loading = true
            await InfoMainWebPage({ orgId: this.orgId, infoType: 8, pageNo: 1, pageSize: 7 })
              .then(res => {
                this.zhData[0].data[0] = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.zhData[0].loaded = false
                console.log(err)
              })
            await InfoMainWebPage({ orgId: this.orgId, infoType: 9, pageNo: 1, pageSize: 7 })
              .then(res => {
                this.zhData[0].data[1] = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.zhData[0].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.zhData[0].loading = false
              })
          }
        },
        {
          type: 'jghq',
          firstLoad: true,
          data: [[], []],
          activeIndex: 0,
          loaded: false,
          loading: false,
          method: async () => {
            this.zhData[1].loaded = true
            this.zhData[1].loading = true
            await SupplyAndDemandInfoWebPage({ orgId: this.orgId, sdType: 1, CType: 1 })
              .then(res => {
                this.zhData[1].data[0] = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.zhData[0].loaded = false
                console.log(err)
              })
            await SupplyAndDemandInfoWebPage({ orgId: this.orgId, sdType: 2, CType: 1 })
              .then(res => {
                this.zhData[1].data[1] = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.zhData[0].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.zhData[1].loading = false
              })
          }
        }
      ],
      jyztTab: [
        {
          name: '家庭农场',
          key: 'JTNC',
          index: 3,
          active: true
        },
        {
          name: '农民合作社',
          key: 'NMHZS',
          index: 2,
          active: false
        },
        {
          name: '龙头企业',
          key: 'LTQY',
          index: 1,
          active: false
        },
        {
          name: '服务组织',
          key: 'FWZZ',
          index: 4,
          active: false
        }
      ],
      ncrcTab: [
        {
          name: '农村劳务',
          key: 'NCLW',
          index: 0,
          active: true
        },
        {
          name: '专业人才',
          key: 'ZYRC',
          index: 1,
          active: false
        }
      ],
      jghqTab: [
        {
          name: '价格行情',
          key: 'SCJG',
          index: 0,
          active: true
        },
        {
          name: '市场分析',
          key: 'FLJG',
          index: 1,
          active: false
        }
      ],
      gqxxTab: [
        {
          name: '供应信息',
          key: 'GYXX',
          index: 0,
          active: true
        },
        {
          name: '求购信息',
          key: 'QGXX',
          index: 1,
          active: false
        }
      ],
      ppTabActive: 0,
      ppData: [
        {
          type: 'zmpp',
          firstLoad: true,
          activeIndex: 0,
          data: [],
          loaded: false,
          loading: false,
          method: () => {
            this.ppData[0].loaded = true
            this.ppData[0].loading = true
            BrandAgricultureProductsWebPage({ pageNo: 1, pageSize: 6, IsFamous: 1 })
              .then(res => {
                this.ppData[0].data = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.ppData[0].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.ppData[0].loading = false
              })
          }
        },
        {
          type: 'qypp',
          firstLoad: true,
          activeIndex: 0,
          data: [],
          loaded: false,
          loading: false,
          method: () => {
            this.ppData[1].loaded = true
            this.ppData[1].loading = true
            BrandPublicWebPage({ pageNo: 1, pageSize: 6 })
              .then(res => {
                this.ppData[1].data = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.ppData[1].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.ppData[1].loading = false
              })
          }
        },
        {
          type: 'ncpp',
          firstLoad: true,
          activeIndex: 0,
          data: [],
          loaded: false,
          loading: false,
          method: () => {
            this.ppData[2].loaded = true
            this.ppData[2].loading = true
            BrandAgricultureProductsWebPage({ pageNo: 1, pageSize: 6, IsFamous: 1 })
              .then(res => {
                this.ppData[2].data = res.data.rows.slice(0, 6)
              })
              .catch(err => {
                this.ppData[2].loaded = false
                console.log(err)
              })
              .finally(() => {
                this.ppData[2].loading = false
              })
          }
        }
      ],
      SightseetData: [],
      BrandDisplayData: [],
      ProductsData: [],
      BrandData: [],
      RegionalBrandData: [],
      ExternalData: [],
      sofaTitle: '',
      /** 发布 */
      Rel: ''
    }
  },
  created() {
    // this.$emit('setMenu', cityMenu)
    this.ExternalListMethod()
    this.SofaMethod()
  },
  mounted() {
    this.initData()
    this.BrandMethod()
  },

  filters: {
    dateFileter: val => {
      return moment(val).format('YYYY-MM-DD')
    },
    expertiseFilter: val => {
      try {
        const array = JSON.parse(val)
        return array.join(',')
      } catch (e) {
        console.log(e)
        return ''
      }
    },
    TanlentexpertiseFilter: (val) => {
        if (val === '0') {
          return '生产型人才'
        } else if (val === '1') {
          return '经营型人才'
        } else if (val === '2') {
          return '社会服务型人才'
        } else {
          return '其他'
        }
      }
  },
  methods: {
    initData() {
      this.$refs.nyInfoBox.setMorePath(this.nyTab[0].morePath)
      this.$refs.ysInfoBox.setMorePath(this.ysTab[0].morePath)
      this.$refs.zhInfoBox.setMorePath(this.zhTab[0].morePath)
      this.nyData[0].method()
      this.ysData[0].method()
      this.zhData[0].method()
      this.zhData[1].method()
    },
    nyTabChange(val) {
      const item = this.nyData[val.index]
      if (!item.loaded) {
        item.method()
      }
      this.nyTabAciveKey = val.key
      this.$refs.nyInfoBox.setMorePath(val.morePath)
    },
    ysTabChange(val) {
      const item = this.ysData[val.index]
      if (!item.loaded) {
        item.method()
      }
      this.ysTabActiveKey = val.key
      this.$refs.ysInfoBox.setMorePath(val.morePath)
    },
    zhTabChange(val) {
      const item = this.ysData[val.index]
      if (!item.loaded) {
        item.method()
      }
      this.zhTabActiveKey = val.key
      this.$refs.ysInfoBox.setMorePath(val.morePath)
    },
    jyztTabChange(val) {
      this.ysData[1].entActiveIndex = val.index
    },
    ncrcTabChange(val) {
      this.ysData[3].subActiveIndex = val.index
    },
    jghqTabChange(val) {
      this.zhData[0].activeIndex = val.index
    },
    gqxxTabChange(val) {
      this.zhData[1].activeIndex = val.index
    },
    ppzsTabChange(val) {
      this.ppTabActive = val.index
      this.nc = val.nc
    },
    BrandMethod() {
      this.orgId = this.$route.query.orgId
      BrandPublicWebPage({ orgId: this.orgId }).then(res => {
        this.RegionalBrandData = res.data.rows.slice(0, 6)
      })
      BrandAgricultureProductsWebPage({ orgId: this.orgId, isfamous: 1, pageNo: 1, pageSize: 6 }).then(res => {
        this.BrandData = res.data.rows.slice(0, 6)
      })
      BrandAgricultureProductsWebPage({ orgId: this.orgId, isfamous: 0, pageNo: 1, pageSize: 6 }).then(res => {
        this.ProductsData = res.data.rows.slice(0, 6)
      })
      SightseeingParkInfoWebPage({ orgId: this.orgId }).then(res => {
        this.SightseetData = res.data.rows.slice(0, 6)
      })
      InfoMainWebPage({ InfoType: 33 }).then(res => {
        this.BrandDisplayData = res.data.rows.slice(0, 6)
      })
    },
    ExternalListMethod() {
      ExternalList().then(res => {
        this.Rel = res.data[0].value
      })
    },
    toBrandAgriculture(id) {
      const go = this.$router.resolve({ path: '/Textcontent', query: { id: id, sytype: 'BrandPublic' } })
      window.open(go.href, '_blank')
    },
    toBrand(id) {
      const go = this.$router.resolve({ path: '/BrandAgricultureProductsPage', query: { id: id } })
      window.open(go.href, '_blank')
    },
    toSightseet(id) {
      const go = this.$router.resolve({ path: '/SightseeingParkPage', query: { id: id } })
      window.open(go.href, '_blank')
    },
    toBrandDisplay(id) {
      const go = this.$router.resolve({ path: '/BrandDisplayPage', query: { id: id } })
      window.open(go.href, '_blank')
    },
    WhiteChick() {
      const go = this.$router.resolve({ path: '/WhitePage' })
      window.open(go.href, '_blank')
    },
    APIPageChick() {
      const go = this.$router.resolve({ path: '/APIPage' })
      window.open(go.href, '_blank')
    },
    SofaMethod() {
      InfoMainWebPage({ infoType: 4 }).then(res => {
        if (res.data.rows.length > 0) {
        this.sofaTitle = res.data.rows[0].title
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.img-bar {
  background-image: url('~@/assets/show/hengfu.jpg');
  background-size: cover;
  height: 166px;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
}
.img-box {
  margin-top: 5px;
  border: 2px solid #207e63;
  height: 160px;
}
.links {
  margin: 10px 0px 0px 10px;
  padding: 0px;

  li {
    display: inline-block;
    padding-left: 20px;
    margin-right: 20px;
    font-size: 16px;
    height: 38px;
    line-height: 38px;
    background: url('~@/assets/icon/dot.png') 3px 16px no-repeat;
    a {
      color: #000;
      &:hover {
        color: #207e63;
      }
    }
  }
}
.info-row {
  height: 38px;
  display: flex;
  line-height: 38px;
  flex-flow: row nowrap;
  color: #000;
  font-size: 16px;
  width: 100%;
  overflow: hidden;

  a&:hover {
    color: green;
  }

  .title-cel {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 696px;
  }
  a {
    color: #000;
    text-decoration: none;
    &:hover {
      color: green;
    }
  }
  .date-cel {
    width: 105px;
    text-align: center;
  }
}
.mini-box {
  display: flex;
  flex-flow: row nowrap;
  height: 100%;

  .mini-box-item {
    flex: 1;
    overflow: hidden;
    margin-right: 3px;
    position: relative;
    &:last-child {
      margin-right: 0px;
    }
  }
}
.ant-card-body {
  padding: 0px;
}

.other-link {
  position: absolute;
  right: 0px;
  margin-top: 10px;
}
.publish-btn {
  position: absolute;
  right: 10px;
  top: 5px;
}
.publish-btn-words{
  font-size: 18px;
  font-weight: 600;
  color: #207e63;
}
.publish-btn-Img{
  font-size: 24px;
}
</style>
